import { createIntegrationOptionValue } from './create'
import { deleteIntegrationOptionValue } from './delete'
import { readIntegrationOptionValues } from './read'
import { updateIntegrationOptionValue } from './update'

export const integrationOptionValues = {
  create: createIntegrationOptionValue,
  delete: deleteIntegrationOptionValue,
  readCollection: readIntegrationOptionValues,
  update: updateIntegrationOptionValue,
}
